var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-cascader", {
    ref: "cascader",
    staticClass: "container-load-type-cascader",
    attrs: {
      value: _vm.value,
      options: _vm.options,
      disabled: _vm.disabled,
      props: { multiple: true },
      filterable: "",
      clearable: "",
      separator: "-",
      placeholder: " "
    },
    on: {
      input: function(val) {
        _vm.$emit("input", val)
      },
      "visible-change": _vm.onVisibleChange
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }